export default {"src":"/_next/static/media/baby8.2f070305.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};